import React from 'react';
import { t, defineMessages } from '@sm/intl';
import { InformationModal } from '../InformationModal';
import announceSurveySharingImage from '../assets/announce_survey_sharing_popup.png';

const COPY = defineMessages({
  HEADLINE: {
    id: 'AnnounceSurveySharing.headline',
    defaultMessage: 'Transfer and share multiple surveys at once',
    description:
      '[Type: Header][Vis.: low] - Announce survey sharing info modal headline',
  },
  SUB_HEADLINE: {
    id: 'AnnounceSurveySharing.sub_headline',
    defaultMessage:
      'Our new feature lets you take action on multiple surveys with just a click',
    description:
      '[Type: Header][Vis.: low] - Announce survey sharing info modal sub headline',
  },
  MESSAGE: {
    id: 'AnnounceSurveySharing.message',
    defaultMessage:
      'Give your teammates access to the right surveys! To get started, just check the box next to one or more surveys, choose how you’d like to share and invite others. It’s that simple.',
    description:
      '[Type: Paragraph][Vis.: low] - Announce survey sharing info modal message',
  },
  DISMISS_CTA_TEXT: {
    id: 'AnnounceSurveySharing.dismiss_cta_text',
    defaultMessage: 'GOT IT',
    description:
      '[Type: Button][Vis.: low] - Announce survey sharing info modal dismiss cta',
  },
});

export const AnnounceSurveySharing: React.FC = () => {
  return (
    <InformationModal
      headline={t(COPY.HEADLINE)}
      subHeadline={t(COPY.SUB_HEADLINE)}
      message={t(COPY.MESSAGE)}
      dismissCtaText={t(COPY.DISMISS_CTA_TEXT)}
      image={() => (
        <img src={announceSurveySharingImage} alt="" aria-hidden="true" />
      )}
    />
  );
};

export default AnnounceSurveySharing;
